import { faAdd } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import VoxelButton from '../../../components/voxel/Buttons/VoxelButton';
import VoxelAlertDialog from '../../../components/voxel/Dialogs/VoxelAlertDialog';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import { CurrentUserGq } from '../../../graphql/users/models/CurrentUserGq';
import AllowedDomainsForm from './AllowedDomainsForm';
import InviteMemberDialog from './InviteMemberDialog';
import MembersTable, { MemberChoices } from './MembersTable';

export interface MembersPageProps {
  handleReload: () => Promise<any>;
  user: CurrentUserGq;
}

export const MembersPage: React.FC<MembersPageProps> = ({ handleReload, user }) => {
  const [currentTab, setCurrentTab] = useState<MemberChoices>(MemberChoices.Members);
  const [showInviteDiaog, setShowInviteDialog] = useState<boolean>(false);
  const [showInviteSuccessDialog, setShowInviteSuccessDialog] = useState<string>(null);

  return (
    <div className="w-full flex flex-col gap-8">
      {/* Dialogs  */}
      <div className='flex flex-row items-center gap-3 justify-between mr-2'>
        <VoxelText variant="title2">Members</VoxelText>
        <VoxelButton
          title='Add members'
          color='primary'
          endIcon={<FontAwesomeIcon icon={faAdd} />}
          onClick={() => setShowInviteDialog(true)}
        />
      </div>
      <AllowedDomainsForm user={user} team={user.team} reload={handleReload} />
      <MembersTable
        reload={handleReload}
        currentUser={user}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
      />
      {/* Dialogs  */}
      <InviteMemberDialog
        open={showInviteDiaog}
        setOpen={() => setShowInviteDialog(false)}
        onSuccess={(result) => handleReload().finally(() => setCurrentTab(MemberChoices.Pending))}
        user={user}
        setShowSuccessDialog={setShowInviteSuccessDialog}
      />
      <VoxelAlertDialog
        open={showInviteSuccessDialog !== null}
        onClose={() => setShowInviteSuccessDialog(null)}
        severity="success"
        title="Success"
      >
        <VoxelDialogContent>
          <VoxelText variant="bread-normal">
            New team member <span className="font-semibold">{showInviteSuccessDialog}</span> was invited
            to the {user?.team?.name} team
          </VoxelText>
        </VoxelDialogContent>
      </VoxelAlertDialog>
    </div>
  );
};

export default MembersPage;
